import type { StockMachineAttachmentDto, StockMachineDto } from '@api/machines'
import { MolsonBox, MolsonTypography } from '@components/reusable'
import { useTranslation } from 'react-i18next'

type StockItemHeaderProps = {
  brand: null | string
  equipment: StockMachineAttachmentDto | StockMachineDto | null
}

export const StockItemHeader = ({
  brand,
  equipment
}: Partial<StockItemHeaderProps>) => {
  const { t } = useTranslation('', {
    keyPrefix: 'common'
  })

  return (
    <MolsonBox display="flex" flexDirection="column" mt={2}>
      <MolsonTypography fontSize={20} fontWeight={700}>
        {`${brand} ${equipment?.modelName}
      (${equipment?.manufactureYear})`}
      </MolsonTypography>
      <MolsonBox alignItems="center" display="flex" flexGrow={0} gap={0.7}>
        <MolsonTypography fontSize={16} fontWeight={700}>
          {t('category')}:
        </MolsonTypography>
        <MolsonTypography> {equipment?.category}</MolsonTypography>
      </MolsonBox>
      <MolsonBox alignItems="center" display="flex" flexGrow={0} gap={0.7}>
        <MolsonTypography fontSize={16} fontWeight={700}>
          {t('stockType')}:
        </MolsonTypography>
        <MolsonTypography>{equipment?.stockType}</MolsonTypography>
      </MolsonBox>
    </MolsonBox>
  )
}
